var _rect, _rect2, _rect3, _rect4, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShecodesLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 300 80",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "titleSheCodesLogo"
  }, "SheCodes logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "titleSheCodesLogo"
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 64,
    height: 64,
    rx: 16,
    fill: "#6B46C1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 0,
    width: 64,
    height: 64,
    rx: 16,
    fill: "#56CCF2"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 40,
    width: 64,
    height: 64,
    rx: 16,
    fill: "#EC4899"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 40,
    width: 64,
    height: 64,
    rx: 16,
    fill: "#FCD34D"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 46,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 36,
    fontWeight: 700,
    fill: "#16172B"
  }, "SheCodes")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShecodesLogo);
export default __webpack_public_path__ + "static/media/shecodes-logo.ca24066c59f51323db3667837d9560d7.svg";
export { ForwardRef as ReactComponent };